'use strict';

+function ($) {
  $.fn.tooltip.Constructor.DEFAULTS.placement = 'auto top';
  $.fn.tooltip.Constructor.DEFAULTS.container = 'body'; // prevents tooltips from inheriting styles from their parents, but dissociates positioning from page layout

  // automatically activate tooltips everywhere (specific options can be set using data-attributes on the tooltip trigger)
  $(document).tooltip({
    selector: '[data-toggle="tooltip"]'
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/tooltip.js
// module id = 21
// module chunks = 0